import Vue from 'vue'

// Estado reactivo de sesión — compartido entre App, router y componentes
const estado = Vue.observable({
  usuario: null,
  permisos: null,
})

// Promise que se resuelve una sola vez cuando la sesión inicial fue verificada.
// El router espera esto antes de evaluar permisos, evitando la condición de carrera.
let _resolverListo
const sesionLista = new Promise((resolve) => { _resolverListo = resolve })

const AyudanteSesion = {
  // ── Getters ──────────────────────────────────────────────────────────────
  usuario() {
    return estado.usuario
  },

  /**
   * @return {Record<keyof typeof import('./../consts.js').PERMISOS, boolean>}
   */
  permisos() {
    const permisos = estado.permisos
    if (permisos) {
      permisos['vistas.vender'] = permisos['ventas.registrar_venta']
        || permisos['ventas.registrar_cuenta']
        || permisos['ventas.registrar_apartado']
        || permisos['ventas.registrar_cotiza']
    }
    return permisos
  },

  can() {
    return function (permiso) {
      const permisos = AyudanteSesion.permisos()
      return permisos?.[permiso] ?? false
    }
  },

  // ── Setters ───────────────────────────────────────────────────────────────
  setSesion(usuario, permisos) {
    estado.usuario = usuario
    estado.permisos = typeof permisos === 'string' ? JSON.parse(permisos) : permisos
    // Marca la sesión como verificada (solo tiene efecto la primera vez)
    _resolverListo()
  },

  limpiarSesion() {
    estado.usuario = null
    estado.permisos = null
    // También resuelve el Promise — la sesión fue verificada (resultado: sin usuario)
    _resolverListo()
  },

  // El router awaits esto antes de evaluar permisos en la primera navegación
  esperarSesion() {
    return sesionLista
  },
}

export default AyudanteSesion
